import { IPlanificationPhaseProfileWorkDay } from '@/entity/planification/planification-phase-profile-work-day';
import { IPlanificationProfileScheduler } from '@/entity/planification/planification-profile-scheduler';

export interface FormatDate {
    date: Date;
    formatted: string;
}

export interface CalculatedDate {
  deleteCount: number
  workoutDates: FormatDate[];
}

export interface ConfigDeleted {
    key: string;
    phase: IPlanificationProfileScheduler;
    deleted: CalculatedDate;
}

export const replaceWorkoutDateByDeletedDate = (configDeleted: ConfigDeleted[]): IPlanificationProfileScheduler[] => {
    const results: IPlanificationProfileScheduler[] = configDeleted.map(cs => {
        const workoutWithDeleted = cs.phase.planificationPhaseProfileWorkDays
            .map(w => ({ ...w, isDeleted: !!cs.deleted.workoutDates.find(wd => wd.date === w.date) }));
        return {
            ...cs.phase,
            planificationPhaseProfileWorkDays: workoutWithDeleted,
        };
    });
    return results;        
};

export const isDeletedSelected = (
    deletedProfiles: IPlanificationProfileScheduler[],
    baseProfiles: IPlanificationProfileScheduler[],
    profile: IPlanificationProfileScheduler): boolean => {
    let selected = false;
    if (profile.parentPhaseId === 0) {
        const shilftChildCount = deletedProfiles.filter(sp => 
            sp.parentPhaseId > 0 && sp.contractLineId === profile.contractLineId).length;
        const childPhaseCount = baseProfiles.filter(p => p.parentPhaseId > 0 && p.contractLineId === profile.contractLineId).length;
        selected = childPhaseCount > 0 && shilftChildCount === childPhaseCount;
    } else {
        selected = !!deletedProfiles.find(sp => 
            sp.contractLineId === profile.contractLineId &&
            sp.employeeId === profile.employeeId &&
            sp.profileId === profile.profileId &&
            sp.indexInPhase === profile.indexInPhase
        );
    }

    return selected;
};
